module.exports = __webpack_public_path__ + "media/promo/advent/images/main-bg-4fbb0771ddc74e00ddc17a8822f2d6b4.jpg";